export default "__VITE_ASSET__40596c54__"